import Lang from '../../core/lang'
import Controller from '../../core/controller'
import Template from '../template'
import Modal from '../modal'
import Manifest from '../../core/manifest'
import Utils from '../../utils/utils'
import Platform from '../../core/platform'
import Account from '../../core/account/account'
import Analytics from '../../services/analytics'
import DeviceInput from '../device_input'

/**
 * Апселл «Отключить рекламу»: карточка-развилка на первый преролл сессии,
 * плашка с отсчётом на повторных, QR-модал в телеграм-бот с оплатой.
 * Цена дублирует тариф Standard на бэке (plans: 29900 коп/30 дней) и
 * лексемы ad_fork_* / ad_bar_text / ad_qr_text / ad_disable — менять синхронно.
 */

// Секунды отсчёта перед роллом на повторных показах (макет: «Реклама через 3»,
// берём с запасом — на пульте дотянуться до «Отключить» дольше, чем мышкой).
const BAR_SECONDS = 5

// Показана ли развилка в этой сессии (module-scope = живёт до перезапуска приложения,
// тот же паттерн, что waite_time в preroll.js).
let fork_showed = false

function botLink(){
    return 'https://t.me/' + Manifest.bot_username + '?start=noads'
}

/**
 * Нужно ли показывать карточку-развилку (первый преролл за сессию)
 */
function needFork(){
    return !fork_showed
}

// Открыт ли QR-модал. На мыши один клик приходит и как hover:enter, и как click —
// без guard'а Modal.open() вызывался дважды, и нижний экземпляр модала было
// уже не закрыть (Modal хранит только последний открытый).
let qr_opened = false

/**
 * QR-модал «оплати в боте». По закрытию обновляет юзера:
 * если премиум уже куплен — зовёт onPaid, иначе onClose.
 * @param {string} [restore] - имя контроллера для восстановления после закрытия;
 *   передавать явно, если вызывающий экран к этому моменту уже закрыт.
 */
function qrModal(onClose, onPaid, restore){
    if(qr_opened) return

    qr_opened = true

    let enabled = restore || Controller.enabled().name

    let html = Template.get('ad_qr')

    // Тот же компонент, что модалка привязки устройства (account/modal.js):
    // на ТВ — полноэкранный layer, на телефоне — мобильная раскладка.
    if(Platform.tv()) html.addClass('layer--' + (Platform.mouse() ? 'wheight' : 'height'))
    else html.addClass('account-modal-split--mobile')

    html.find('.account-modal-split__bot-link')
        .text('@' + Manifest.bot_username)
        .attr('href', botLink())

    let code = html.find('.account-modal-split__qr-code')

    Utils.qrcode(botLink(), code, ()=>{
        code.addClass('account-modal-split__qr-code--text').text('@' + Manifest.bot_username)
    })

    Analytics.track('ad', 'qr_shown')

    // Остановить активный опрос оплаты (назначается после Modal.open).
    let stop_watch = ()=>{}

    let close = ()=>{
        if(!qr_opened) return

        qr_opened = false

        stop_watch()

        Modal.close()

        Controller.toggle(enabled)

        // Юзер мог оплатить с телефона, пока модал был открыт
        Account.updateUser(()=>{
            if(Account.hasPremium()){
                Analytics.track('ad', 'qr_paid')

                if(onPaid) onPaid()
            }
            else if(onClose) onClose()
        })
    }

    Modal.open({
        title: '',
        html: html,
        size: Platform.tv() ? 'full' : 'medium',
        scroll: {nopadding: true},
        // Выше оверлея преролла (.ad-preroll z-index 60), иначе модал,
        // открытый с плашки отсчёта, рисуется ПОД ним и невидим
        zIndex: 70,
        // Без кнопки «Закрыть» — как модалка привязки: закрытие по Back (onBack).
        onBack: close
    })

    // Пока открыт QR — часто опрашиваем юзера: оплатил в боте с телефона →
    // премиум подхватится за секунды, модал сам закроется и фильм пойдёт без рекламы.
    stop_watch = Account.watchUser(()=>{
        if(Account.hasPremium()) close()
    })
}

/**
 * Карточка-развилка «Как будете смотреть?» (первый преролл сессии).
 * @param {Object} params - {onAds: смотреть с рекламой, onSkip: продолжить без рекламы (куплено),
 *   onCancel: закрыл QR не оплатив — запуск фильма отменяется, никаких модалок дальше}
 */
function fork(params){
    fork_showed = true

    let enabled = Controller.enabled().name
    let html    = Template.get('ad_fork')

    let close = ()=>{
        if(!html) return

        html.remove()

        html = null
    }

    let toAds = ()=>{
        if(!html) return

        Analytics.track('ad', 'fork_ads')

        close()

        Controller.toggle(enabled)

        params.onAds()
    }

    html.find('.selector').on('hover:enter click',(e)=>{
        if(!html) return

        // Один клик мышью приходит и как hover:enter, и как click — глушим дубль
        if(!DeviceInput.noDubleClick(e)) return

        let action = $(e.currentTarget).data('action')

        if(action == 'paid'){
            Analytics.track('ad', 'fork_upsell')

            // Развилку закрываем, QR показываем на чистом фоне
            close()

            qrModal(()=>{
                // Закрыл QR без оплаты — полный выход, юзер остаётся на карточке
                params.onCancel()
            },()=>{
                // Оплатил — фильм без рекламы
                params.onSkip()
            }, enabled)
        }
        else toAds()
    })

    $('body').append(html)

    Analytics.track('ad', 'fork_shown')

    Controller.add('ad_fork',{
        toggle: ()=>{
            Controller.collectionSet(html)
            Controller.collectionFocus(html.find('[data-action="ads"]')[0], html)
        },
        left: ()=>{
            Navigator.move('left')
        },
        right: ()=>{
            Navigator.move('right')
        },
        back: toAds
    })

    Controller.toggle('ad_fork')
}

/**
 * Плашка с отсчётом перед роллом (повторные показы).
 * Рисуется внутрь оверлея .ad-preroll, управляет своим контроллером.
 * @param {Object} overlay - jQuery .ad-preroll
 * @param {Object} params - {onStart: запустить рекламу, onDisable: юзер жмёт «Отключить»
 *   (вызывающий закрывает оверлей и показывает QR-модал)}
 */
function countdown(overlay, params){
    let seconds = BAR_SECONDS
    let done    = false

    let bar = $(`
        <div class="ad-countdown">
            <div class="ad-countdown__info">
                <div class="ad-countdown__timer">${Lang.translate('ad_after')} <span>${seconds}</span></div>
                <div class="ad-countdown__text">${Lang.translate('ad_bar_text')}</div>
            </div>
            <div class="ad-countdown__buttons">
                <div class="ad-countdown__button selector" data-action="later">${Lang.translate('ad_not_now')}</div>
                <div class="ad-countdown__button ad-countdown__button--accent selector" data-action="off">${Lang.translate('ad_turn_off')}</div>
            </div>
        </div>
    `)

    overlay.append(bar)

    Analytics.track('ad', 'bar_shown')

    let tik

    let finish = (call)=>{
        if(done) return

        done = true

        clearInterval(tik)

        bar.remove()

        call()
    }

    let start = ()=>finish(params.onStart)

    let tick = ()=>{
        seconds--

        if(seconds <= 0) start()
        else bar.find('.ad-countdown__timer span').text(seconds)
    }

    tik = setInterval(tick, 1000)

    bar.find('.selector').on('hover:enter click',(e)=>{
        if(done) return

        // Дубль hover:enter + click от одного клика мышью
        if(!DeviceInput.noDubleClick(e)) return

        if($(e.currentTarget).data('action') == 'off'){
            Analytics.track('ad', 'bar_upsell')

            finish(params.onDisable)
        }
        else start()
    })

    Controller.add('ad_countdown',{
        toggle: ()=>{
            Controller.collectionSet(overlay)
            Controller.collectionFocus(bar.find('[data-action="later"]')[0], overlay)
        },
        left: ()=>{
            Navigator.move('left')
        },
        right: ()=>{
            Navigator.move('right')
        },
        back: start
    })

    Controller.toggle('ad_countdown')
}

export default {
    needFork,
    fork,
    countdown,
    qrModal
}
